<template>
  <div>
    <div v-if="loading" class="text-center">
      <small class="text-muted">Cargando...</small><br />
      <div class="lds-circle"><div></div></div>
    </div>
    <div v-else>
      <transition appear name="slide-fade">
        <div>
          <div>
            <div class="basic-form">
              <div class="form-group mb-3">
                <label>Contraseña actual</label>
                <div class="form-input">
                  <input
                    v-model="password"
                    type="password"
                    placeholder="Contraseña actual"
                    id="dz-password_1"
                    class="form-control input_pass be-0"
                  />
                  <span
                    v-on:click="toggle_input_pass(1)"
                    class="input_icon_pass"
                  >
                    <i class="fa fa-eye"></i>
                  </span>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Nueva contraseña</label>

                <div class="form-input">
                  <input
                    v-model="nuevo_password"
                    type="password"
                    placeholder="Nueva contraseña"
                    id="dz-password_2"
                    class="form-control input_pass be-0"
                  />
                  <span
                    v-on:click="toggle_input_pass(2)"
                    class="input_icon_pass"
                  >
                    <i class="fa fa-eye"></i>
                  </span>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Confirma tu nueva contraseña</label>
                <div class="form-input">
                  <input
                    v-model="nuevo_password_confirm"
                    type="password"
                    placeholder="Nueva contraseña"
                    id="dz-password_3"
                    class="form-control input_pass be-0"
                  />
                  <span
                    v-on:click="toggle_input_pass(3)"
                    class="input_icon_pass"
                  >
                    <i class="fa fa-eye"></i>
                  </span>
                </div>
              </div>
              <div class="mt-2">
                <a
                  v-on:click="update_clave"
                  href="javascript:void(0)"
                  class="btn mt-2 btn-primary w-100 btn-rounded"
                  >Actualizar</a
                >
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "Cambiar_clave",
  metaInfo: {
    title: "Actualizar contraseña - Reddy App",
  },
  data() {
    return {
      loading: true,
      password: null,
      nuevo_password: null,
      nuevo_password_confirm: null,
    };
  },
  props: {
    session: Object,
  },
  created: function () {},
  methods: {
    update_clave: function () {
      if (this.password == null || this.password.trim().length == 0) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "<i class='fa fa-exclamation-circle'></i> Ups!",
          text: "Digita tu contraseña actual",
        });
        return false;
      }
      if (
        this.nuevo_password == null ||
        this.nuevo_password.trim().length == 0
      ) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "<i class='fa fa-exclamation-circle'></i> Ups!",
          text: "Digita tu nueva contraseña ",
        });
        return false;
      }
      if (this.nuevo_password.trim().length < 6) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "<i class='fa fa-exclamation-circle'></i> Ups!",
          text: "Digita una contraseña de seis o más caracteres.",
        });
        return false;
      }
      if (
        this.nuevo_password_confirm == null ||
        this.nuevo_password_confirm.trim().length == 0
      ) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "<i class='fa fa-exclamation-circle'></i> Ups!",
          text: "Confirma tu nueva contraseña",
        });
        return false;
      }
      if (this.nuevo_password_confirm != this.nuevo_password) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "<i class='fa fa-exclamation-circle'></i> Ups!",
          text: "La contraseña digitada no coincide con la confirmación",
        });
        return false;
      }
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let params = {
        password: this.password,
        nuevo_password: this.nuevo_password,
      };
      axios
        .post(this.$base_url + "membresias/update_password", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: response.data.message,
            });
          } else {
            vm.$notify({
              type: "success",
              group: "foo",
              title: "<i class='fa fa-check-circle'></i> Excelente!",
              text: "Has actualizado tus contraseña.",
            });
            vm.loading = false;
          }
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
    toggle_input_pass: function (who) {
      if (document.getElementById("dz-password_" + who).type == "password") {
        document.getElementById("dz-password_" + who).type = "text";
      } else {
        document.getElementById("dz-password_" + who).type = "password";
      }
    },
  },
  mounted: function () {
    this.loading = false;
  },
};
</script>
